import React from "react";

const Header = () => {
  return (
    <header>
      <h1 title="Play Me!">WORDLE</h1>
    </header>
  );
};

export default Header;
